import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Componentes del módulo de RRHH
import DashboardRRHH from "./components/DashboardRRHH";
import Empleados from "./components/Empleados";
import Nomina from "./components/Nomina";
import Asistencias from "./components/Asistencias";
import Vacaciones from "./components/Vacaciones";
import Evaluaciones from "./components/Evaluaciones";
import Capacitaciones from "./components/Capacitaciones";
import Documentos from "./components/Documentos";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";

function RRHH() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [tabValue, setTabValue] = useState(0);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const renderContent = () => {
    switch (tabValue) {
      case 0:
        return <DashboardRRHH />;
      case 1:
        return <Empleados />;
      case 2:
        return <Nomina />;
      case 3:
        return <Asistencias />;
      case 4:
        return <Vacaciones />;
      case 5:
        return <Evaluaciones />;
      case 6:
        return <Capacitaciones />;
      case 7:
        return <Documentos />;
      default:
        return <DashboardRRHH />;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Recursos Humanos
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <AppBar position="static">
                  <Tabs orientation="horizontal" value={tabValue} onChange={handleSetTabValue}>
                    <Tab
                      label="Dashboard"
                      icon={
                        <Icon fontSize="small" sx={{ mt: -0.25 }}>
                          dashboard
                        </Icon>
                      }
                    />
                    <Tab
                      label="Empleados"
                      icon={
                        <Icon fontSize="small" sx={{ mt: -0.25 }}>
                          people
                        </Icon>
                      }
                    />
                    <Tab
                      label="Nómina"
                      icon={
                        <Icon fontSize="small" sx={{ mt: -0.25 }}>
                          payments
                        </Icon>
                      }
                    />
                    <Tab
                      label="Asistencias"
                      icon={
                        <Icon fontSize="small" sx={{ mt: -0.25 }}>
                          event_available
                        </Icon>
                      }
                    />
                    <Tab
                      label="Vacaciones"
                      icon={
                        <Icon fontSize="small" sx={{ mt: -0.25 }}>
                          beach_access
                        </Icon>
                      }
                    />
                    <Tab
                      label="Evaluaciones"
                      icon={
                        <Icon fontSize="small" sx={{ mt: -0.25 }}>
                          assessment
                        </Icon>
                      }
                    />
                    <Tab
                      label="Capacitaciones"
                      icon={
                        <Icon fontSize="small" sx={{ mt: -0.25 }}>
                          school
                        </Icon>
                      }
                    />
                    <Tab
                      label="Documentos"
                      icon={
                        <Icon fontSize="small" sx={{ mt: -0.25 }}>
                          folder
                        </Icon>
                      }
                    />
                  </Tabs>
                </AppBar>
                <MDBox p={3}>{renderContent()}</MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default RRHH;
